var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('p',[_vm._v("页面正在加载中...")]),_c('div',{attrs:{"id":"colorfulPulse"}},[_c('span',{staticClass:"item-1"}),_c('span',{staticClass:"item-2"}),_c('span',{staticClass:"item-3"}),_c('span',{staticClass:"item-4"}),_c('span',{staticClass:"item-5"}),_c('span',{staticClass:"item-6"}),_c('span',{staticClass:"item-7"})])])
}]

export { render, staticRenderFns }